import { __assign } from "tslib";
import { INTERVAL_TO_PRECISION } from '@keen.io/charts-utils';
export var setChartSettings = function (_a) {
    var query = _a.query, componentSettings = _a.componentSettings;
    var _b = componentSettings, type = _b.type, usePercentDifference = _b.usePercentDifference;
    var interval = query.interval;
    var settings = {};
    if (!Object.keys(query).length)
        return settings;
    if (interval) {
        var secondaryValueDescription = null;
        if (type === 'comparison') {
            secondaryValueDescription = getSuffix(interval, 'Previous');
        }
        if (type === 'difference') {
            secondaryValueDescription = getSuffix(interval, 'Change from the previous');
        }
        if (usePercentDifference) {
            secondaryValueDescription = getSuffix(interval, 'Percentage change from the previous');
        }
        if (secondaryValueDescription) {
            settings = __assign(__assign({}, settings), { secondaryValueDescription: secondaryValueDescription });
        }
    }
    settings = __assign({}, settings);
    return settings;
};
export var getSuffix = function (interval, prefix) {
    if (Object.keys(INTERVAL_TO_PRECISION).includes(interval)) {
        return prefix + " " + INTERVAL_TO_PRECISION[interval];
    }
    return interval.split('_').join(' ').replace('every', prefix);
};
